// import Slider from 'components/menu';
// export for others scripts to use
import Choices from "choices.js"

const Select = () => {
    // Pass single element
    const selects = document.querySelectorAll('.js-choice');
    if(selects)
        selects.forEach((el) => {
            const choices = new Choices(el, {
                searchEnabled: false
            });
        })
}
export default Select;